import MainComponent from "components/Main";
import ItemHuman from "components/ItemHuman";

import PropTypes from 'prop-types';

import { ReactComponent as BufferIcon } from 'icons/components/buffer.svg';

import './index.less';
import './themes/default.less';

export default class ListBuffer extends MainComponent {
    static propTypes = {
        items: PropTypes.array,
        updateVisit: PropTypes.func
    };

    static defaultProps = {
        items: [],
        updateVisit: null
    };

    removeItem(id) {
        this.props.openDialog("cancelApp", this.removeItemsSend.bind(this, id));
    }

    removeItemsSend(id, { replaceReasonId, replaceReasonComment }) {
        this.props.updateVisit(id, {
            status: "WI_CANCELED",
            addedToBuffer: null,
            changedBy: this.props.info.profile?.id || null,
            changedTime: this._helper.date.toStr(),
            replaceReasonId,
            replaceReasonComment
        });
    }

    async checkValidTime(id) {
        const { buffer/*, visits */ } = this.props.info;

        const bufferVist = buffer.find(it => it.id === id);
        const { beginDate, endDate, cabinetId, domainId, doctorId } = bufferVist;
        const d = this._helper.date.fromStr(beginDate);
        const d2 = this._helper.date.fromStr(endDate);
        const cd = this._helper.date.fromStr(beginDate);

        const checkDate1 = this._helper.date.setTime(cd, "00:00");
        const checkDate2 = this._helper.date.setTime(cd, "23:59");

        const shedule = await this._request.doctorsScheduleShortList.getByCabinetVeDoctor(domainId, doctorId, cabinetId, checkDate1, checkDate2);
        if (shedule.data?.length) {
            let error = true;
            shedule.data.forEach(shed => {
                const { beginDate: bd, endDate: ed } = shed;
                const dd1 = this._helper.date.toLocal(bd);
                const dd2 = this._helper.date.toLocal(ed);
                const res = this._helper.date.intervalExceedsBounds(new Date(dd1), new Date(dd2), new Date(beginDate), new Date(endDate));
                if (!res)
                    error = false;
            });

            if (error)
                return { error: 2, doctorId, cabinetId };

        } else
            return { error: 2, doctorId, cabinetId };

        const visitsResp = await this._request.visits.getForCabinet(domainId, cabinetId, checkDate1, checkDate2);
        const visits = visitsResp?.data || [];

        let visit = false;
        if (visits.filter(it => it.cabinetId === cabinetId).some(it => {
            const dd = this._helper.date.fromStr(it.beginDate);
            const dd2 = this._helper.date.fromStr(it.endDate);

            const intervalsOverlap = this._helper.date.intervalsOverlap(d, d2, dd, dd2);
            if (intervalsOverlap)
                visit = it;

            return intervalsOverlap;
        })) {
            return { error: 1, cabinetId, doctorId, visit };
        }

        return { error: 0 };
    }

    async moveItemBack(id, client) {
        const fio = this._helper.string.formatFullName(client);
        const text = `^${this.tr("appointment.clientReturned").replace("$1", fio)}`;
        this._helper.showLoading();
        const check = await this.checkValidTime(id);
        const { error, cabinetId, doctorId } = check;
        this._helper.hideLoading();

        if (error === 0) {
            this.props.updateVisit(
                id,
                { status: "WI_CREATED", addedToBuffer: null, callConfirmed: false },
                this._helper.showNotify.bind(this._helper, "app.moveApp", text)
            );
        } else if (error === 1) {
            this._helper.showNotifyPopup({
                type: "error",
                label: this.tr("main.errorTimeCrossing"),
                text: this.tr("main.checkTime") + ` доктор: ${this._helper.getDoctorNameById(doctorId)} кабинет: "${this._helper.getCabinetInfo(cabinetId).title}"`,
            });
        } else if (error === 2) {
            this._helper.showNotifyPopup({
                type: "error",
                label: "Восстановление невозможно",
                text: `Расписание изменилось доктор: ${this._helper.getDoctorNameById(doctorId)} кабинет: "${this._helper.getCabinetInfo(cabinetId).title}" не соответствуют данным восстановления`,
            });
        }
    }

    formTooltipText(info, clientStr, period, duration, isNotNew) {
        const { client, addedToBuffer, changedBy, reasonName, doctorId, comment } = info;
        const doc = this.props.getDoctorById(doctorId);
        const changedDoc = this.props.getDoctorById(changedBy);
        const docStr = doc?.id ? this._helper.string.formatFullName(doc) : "";

        let str = client?.id ? `${this.tr("clientStatuses.PERMANENT")}: ${clientStr}` : clientStr;

        str += "<br>";

        if (isNotNew)
            str += (`<br>${this.tr("client.period")}: ${period}`);

        str += (`<br>${this.tr("main.duration")}: ${duration}`);

        if (docStr)
            str += (`<br>${this.tr("client.doctor")}: ${docStr}`);
        if (reasonName)
            str += (`<br>${this.tr("main.reason")}: ${reasonName}`);

        if (comment)
            str += (`<br><br>${this.tr("main.comment")}:<br>${comment}`);

        str += "<br>";
        str += (`<br>${this.tr("buffer.added")}: ${this._helper.date.toDateTimeStr(addedToBuffer)}`);
        str += (`<br>${this.tr("buffer.movedBy")}: ${this._helper.string.formatFullName(changedDoc)}`);

        return str;
    }

    insertItem(i, info) {
        const { id, beginDate, endDate, status } = info;
        const client = info.client || {};

        const d = this._helper.date.fromStr(beginDate);
        const d2 = this._helper.date.fromStr(endDate);

        const isNotNew = status !== "WI_BUFFER_CREATED";
        const isSystem = status !== "WI_BUFFER";
        const dateInt = this._helper.date.toTimeStr(d) + "-" + this._helper.date.toTimeStr(d2);
        const clientStr = client?.id ? this._helper.string.formatFullName(client, "short") : this.tr("main.emptyPatient");
        const duration = this._helper.date.formatTimeDuration(d2, d);
        const period = this._helper.date.toDateStr(d) + ", " + dateInt;
        info.callConfirmed = false;

        return (
            <ItemHuman
                key={i}
                draggable={true}
                onDragStart={() => {
                    globalThis.currentDropValue = info;
                }}
                className="itemBuffer"
                tooltip={this.formTooltipText(info, clientStr, period, duration, isNotNew)}
                firstRow={clientStr}
                secondRow={(
                    <div>
                        {isNotNew && (
                            <div>{period}</div>
                        )}
                        <div>{duration}</div>
                    </div>
                )}
                iconLeft={isSystem ? (
                    <BufferIcon className="icon" style={{ opacity: "0" }} />
                ) : (
                    <BufferIcon className="icon hand" data-tooltip="main.restore" onClick={this.moveItemBack.bind(this, id, client)} />
                )}
                removeCb={this.removeItem.bind(this, id)}
                removeTooltip="client.delete"
            />
        );
    }

    render() {
        const { items } = this.props;

        return (
            <div className="bufferList flex col gap8">
                {items.map((it, i) => this.insertItem(i, it))}
            </div>
        );
    }
}
